<div class="period-picker">
  <button
    class="period-btn"
    (click)="openPeriodPicker()"
    [disabled]="disabled">
    <span class="period-display">
      {{ formatPeriodDisplay() }}
    </span>
    <img
      src="assets/icons/arrowDownCalendar.png"
      alt="Selecionar período"
      class="period-arrow"
      [class.rotated]="isPeriodPickerOpen">
  </button>

  <div class="period-selector" *ngIf="isPeriodPickerOpen">
    <div class="selector-content">
      <div class="year-selector-container">
        <select
          class="year-selector"
          [(ngModel)]="selectedYear"
          (change)="onYearChange()"
          [disabled]="disabled">
          <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
        </select>
      </div>

      <div class="month-grid">
        <button
          *ngFor="let month of availableMonths; let i = index"
          class="month-btn"
          [class.active]="selectedMonth === i + 1"
          [class.disabled]="isMonthDisabled(i + 1) || disabled"
          (click)="selectMonth(i + 1)"
          [disabled]="isMonthDisabled(i + 1) || disabled">
          {{ getShortMonthName(month) }}
        </button>
      </div>
    </div>
  </div>
</div>
